var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 396.3 80",
    style: {
      enableBackground: "new 0 0 396.3 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#ffff;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48,11.3c2.5,0,4.8,0,7.3,0c0,2.6,0,5,0,7.5c0,11.4,0,22.9,0,34.3c0,0.8-0.3,1.6-0.8,2.3 c-1.8,2.4-3.9,4.5-6.5,6.4C48,44.9,48,28.2,48,11.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M39.2,18.2c2.2,0,5-0.1,7.1,0c0,0,0.1,29.4,0.1,43.2c0,1.2-0.2,1.7-1.1,2.4c-0.7,0.6-1.3,1.3-6.1,2.7 C39.2,50.2,39.2,34.3,39.2,18.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.1,67c-2.1,0-4.9,0.1-7,0c-0.3,0,0-27.5,0-40.4c0-0.4,0-0.9,0-1.4c2.4,0,4.7,0,7.1,0 C37.3,39,37.1,53,37.1,67z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.1,32.1c2.4,0,5,0,7.4,0c0,1.2,0,0.8,0,1.2c0,10.7,0,21.5,0,32.2c0,1.2-0.4,1.5-1.4,1.4 c-2.3-0.2-4.1-1.5-5.6-3.1c-0.2-0.2-0.2-0.6-0.2-0.9C21.2,52.7,21,32.3,21.1,32.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.8,68.6c11.3,0.5,20-4.5,26.5-13.5c4.2-5.7,6.4-12.3,6.3-19.4c-0.1-4.9-1.4-9.5-4.2-13.6 c-0.1-0.2-0.3-0.4-0.4-0.7c3.4,3.6,5.4,7.8,6.1,12.7C65.5,43,63,51,57.4,57.9c-4,5-9,8.4-15.1,10.2C38.1,69.4,33.9,69.8,29.8,68.6z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.6,58.8c-6.1-8.5-6.4-20.4,0.8-31.3C24.5,17,36.8,12.9,45.8,15.2c-11.5-0.3-20.2,4.7-26.4,14 C13.3,38.5,11.9,48.4,16.6,58.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.3,62.5c0,1.4,0,2.8,0,4.2c-1.9,0-3.7,0-5.6,0C51.6,65.2,53.4,63.9,55.3,62.5z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.2,19.8h3.1l3.8,11.5l3.9-11.5H88l2.8,16.5h-3l-1.8-10.4l-3.5,10.4h-2.8l-3.5-10.4l-1.8,10.4h-3.1 L74.2,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M93.3,19.8h9v3.1h-5.9v3h5.9v3h-5.9v4.3h5.9v3.1h-9V19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M112.5,29l-0.4-0.5l-4.7,7.8h-3.7l6.1-9.6l-5.5-7h3.8l4.5,5.9v-5.9h3.2v5.9l4.5-5.9h3.8l-5.5,7l6.1,9.6h-3.7 l-4.7-7.8l-0.4,0.5v7.3h-3.2V29z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132.1,19.8h3.2l5.3,13.6h1.8v5.4h-3v-2.5H128v2.5h-3v-5.4h1.8L132.1,19.8z M133.7,24.2l-3.6,9.2h7.2 L133.7,24.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.1,32.6l-5.9-12.7h3.5l3.9,9.2l3.2-9.2h3.2l-4.4,11.8c-0.8,2-1.6,3.4-2.5,4.1c-0.9,0.7-1.8,1-2.8,1 c-1.6,0-3.1-0.8-4.5-2.4l2.1-2.1c0.8,1,1.6,1.4,2.4,1.4c0.4,0,0.7-0.1,0.9-0.3C148.5,33.3,148.8,33,149.1,32.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159.2,19.8h3.2v6.2h5.5v-6.2h3.2v16.5h-3.2v-7.2h-5.5v7.2h-3.2V19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M179.9,19.8h3.2l6.4,16.5h-3.3l-1.3-3.4h-6.7l-1.3,3.4h-3.3L179.9,19.8z M181.5,24.2l-2.2,5.7h4.4L181.5,24.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.9,19.8h3.3c1.8,0,3.1,0.2,3.9,0.5c0.8,0.3,1.4,0.9,1.9,1.6c0.5,0.7,0.7,1.6,0.7,2.7 c0,1.2-0.3,2.1-0.9,2.9c-0.6,0.8-1.4,1.3-2.5,1.6c-0.6,0.2-1.7,0.3-3.3,0.3v7h-3.1V19.8z M195,26.3h1c0.8,0,1.3-0.1,1.6-0.2 s0.5-0.3,0.7-0.6c0.2-0.3,0.3-0.6,0.3-0.9c0-0.6-0.2-1.1-0.7-1.4c-0.4-0.2-1-0.3-2-0.3H195V26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M212.5,19.4c2.3,0,4.3,0.8,6,2.5s2.5,3.8,2.5,6.2c0,2.4-0.8,4.5-2.5,6.1s-3.7,2.5-6,2.5 c-2.5,0-4.5-0.9-6.2-2.6s-2.5-3.8-2.5-6.1c0-1.6,0.4-3,1.1-4.4c0.8-1.3,1.8-2.4,3.2-3.2C209.6,19.8,211,19.4,212.5,19.4z  M212.5,22.5c-1.5,0-2.8,0.5-3.9,1.6s-1.6,2.4-1.6,4.1c0,1.8,0.7,3.3,2,4.3c1,0.8,2.2,1.2,3.5,1.2c1.5,0,2.8-0.5,3.8-1.6 s1.6-2.4,1.6-4c0-1.6-0.5-2.9-1.6-4C215.3,23,214,22.5,212.5,22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M229.4,19.8h3.2l5.3,13.6h1.8v5.4h-3v-2.5h-11.4v2.5h-3v-5.4h1.8L229.4,19.8z M231.1,24.2l-3.6,9.2h7.2 L231.1,24.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M241.8,19.8h3.2v6.2h5.5v-6.2h3.2v16.5h-3.2v-7.2H245v7.2h-3.2V19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M262.5,19.8h3.2l6.4,16.5h-3.3l-1.3-3.4h-6.7l-1.3,3.4h-3.3L262.5,19.8z M264.1,24.2l-2.2,5.7h4.4L264.1,24.2z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M284.2,19.8v16.5H281v-6.6h-0.8l-3.3,6.6h-3.4l3.7-7.2c-2.2-0.6-3.3-2.1-3.3-4.3c0-0.8,0.1-1.5,0.3-2.1 c0.2-0.6,0.6-1.1,1-1.5c0.4-0.4,0.9-0.7,1.5-0.9c0.6-0.2,1-0.3,1.3-0.3s1.2-0.1,2.7-0.1H284.2z M281,26.6v-3.7h-0.9 c-0.8,0-1.3,0-1.7,0.1c-0.3,0.1-0.6,0.3-0.8,0.6c-0.2,0.3-0.3,0.7-0.3,1.2c0,0.7,0.2,1.2,0.7,1.4c0.4,0.3,1.1,0.4,2.1,0.4H281z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M294.4,19.8h11.9v16.5h-3.2V22.8h-5.5v13.6h-3.2V19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M310,19.8h3.3c1.8,0,3.1,0.2,3.9,0.5c0.8,0.3,1.4,0.9,1.9,1.6c0.5,0.7,0.7,1.6,0.7,2.7c0,1.2-0.3,2.1-0.9,2.9 s-1.4,1.3-2.5,1.6c-0.6,0.2-1.7,0.3-3.3,0.3v7H310V19.8z M313.2,26.3h1c0.8,0,1.3-0.1,1.6-0.2s0.5-0.3,0.7-0.6s0.3-0.6,0.3-0.9 c0-0.6-0.2-1.1-0.7-1.4c-0.4-0.2-1-0.3-2-0.3h-0.9V26.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M322.9,19.8h9v3.1H326v3h5.9v3H326v4.3h5.9v3.1h-9V19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M336.5,19.8h3.1l3.8,11.5l3.9-11.5h3.1l2.8,16.5h-3l-1.8-10.4l-3.5,10.4H342l-3.5-10.4l-1.8,10.4h-3.1 L336.5,19.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M367.6,19.8v16.5h-3.1V26l-6.2,10.3h-2.7V19.8h3.1v10.7l6.2-10.7H367.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M381.1,19.8v16.5H378v-6.6h-0.8l-3.3,6.6h-3.4l3.7-7.2c-2.2-0.6-3.3-2.1-3.3-4.3c0-0.8,0.1-1.5,0.3-2.1 c0.2-0.6,0.6-1.1,1-1.5c0.4-0.4,0.9-0.7,1.5-0.9c0.6-0.2,1-0.3,1.3-0.3s1.2-0.1,2.7-0.1H381.1z M378,26.6v-3.7h-0.9 c-0.8,0-1.3,0-1.7,0.1c-0.3,0.1-0.6,0.3-0.8,0.6c-0.2,0.3-0.3,0.7-0.3,1.2c0,0.7,0.2,1.2,0.7,1.4c0.4,0.3,1.1,0.4,2.1,0.4H378z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M83.3,61.4l-4.6-12.1L74,61.4h-3.3l6.4-16.5h3.2l6.4,16.5H83.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M100.6,44.8v16.5h-3.1V51l-6.2,10.3h-2.7V44.8h3.1v10.7l6.2-10.7H100.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.7,44.8h3.2l5.3,13.6h1.8v5.4h-3v-2.5h-11.4v2.5h-3v-5.4h1.8L109.7,44.8z M111.3,49.2l-3.6,9.2h7.2 L111.3,49.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.1,44.8h9v3.1h-5.9v3h5.9v3h-5.9v4.3h5.9v3.1h-9V44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M134,44.8h3.3c1.8,0,3.1,0.2,3.9,0.5c0.8,0.3,1.4,0.9,1.9,1.6c0.5,0.7,0.7,1.6,0.7,2.7c0,1.2-0.3,2.1-0.9,2.9 c-0.6,0.8-1.4,1.3-2.5,1.6c-0.6,0.2-1.7,0.3-3.3,0.3v7H134V44.8z M137.2,51.3h1c0.8,0,1.3-0.1,1.6-0.2c0.3-0.1,0.5-0.3,0.7-0.6 c0.2-0.3,0.3-0.6,0.3-0.9c0-0.6-0.2-1.1-0.7-1.4c-0.4-0.2-1-0.3-2-0.3h-0.9V51.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154.7,44.4c2.3,0,4.3,0.8,6,2.5c1.7,1.7,2.5,3.8,2.5,6.2c0,2.4-0.8,4.5-2.5,6.1s-3.7,2.5-6,2.5 c-2.5,0-4.5-0.9-6.2-2.6s-2.5-3.8-2.5-6.1c0-1.6,0.4-3,1.1-4.4c0.8-1.3,1.8-2.4,3.2-3.2C151.7,44.8,153.2,44.4,154.7,44.4z  M154.7,47.5c-1.5,0-2.8,0.5-3.9,1.6c-1,1.1-1.6,2.4-1.6,4.1c0,1.8,0.7,3.3,2,4.3c1,0.8,2.2,1.2,3.5,1.2c1.5,0,2.8-0.5,3.8-1.6 s1.6-2.4,1.6-4c0-1.6-0.5-2.9-1.6-4C157.5,48,156.2,47.5,154.7,47.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M166.2,61.4V44.8h2.6c1.5,0,2.6,0.1,3.3,0.3c1,0.3,1.8,0.7,2.4,1.5c0.6,0.7,0.9,1.5,0.9,2.5 c0,0.6-0.1,1.2-0.4,1.7c-0.3,0.5-0.7,1-1.3,1.4c1,0.5,1.7,1.1,2.2,1.8c0.5,0.7,0.7,1.5,0.7,2.5c0,0.9-0.2,1.8-0.7,2.5 c-0.5,0.8-1.1,1.3-1.9,1.7c-0.8,0.4-1.8,0.6-3.1,0.6H166.2z M169.4,47.8v3.5h0.7c0.8,0,1.3-0.2,1.7-0.5c0.4-0.3,0.6-0.8,0.6-1.3 c0-0.5-0.2-0.9-0.5-1.2c-0.4-0.3-0.9-0.5-1.6-0.5H169.4z M169.4,54.1v4.2h0.8c1.3,0,2.2-0.2,2.6-0.5c0.5-0.3,0.7-0.8,0.7-1.4 c0-0.7-0.3-1.3-0.8-1.7c-0.5-0.4-1.4-0.6-2.7-0.6H169.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M186,61.4V44.8h8.6v3.1h-5.5v3.2h0.7c1.4,0,2.5,0.2,3.4,0.5c0.9,0.3,1.6,0.9,2.2,1.7c0.6,0.8,0.9,1.9,0.9,3 c0,1.2-0.2,2.1-0.7,2.8c-0.4,0.7-1,1.2-1.8,1.7c-0.8,0.4-1.8,0.6-3.2,0.6H186z M189.1,53.9v4.5h0.8c1.4,0,2.3-0.2,2.7-0.6 c0.4-0.4,0.6-0.9,0.6-1.5c0-1.6-1.1-2.4-3.4-2.4H189.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M211.1,44.8v16.5H208V51l-6.2,10.3h-2.7V44.8h3.1v10.7l6.2-10.7H211.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M215.7,57.1c0.8,1.2,1.8,1.7,2.9,1.7c0.7,0,1.3-0.2,1.8-0.6s0.7-1,0.7-1.7c0-0.7-0.2-1.2-0.7-1.7 c-0.4-0.4-1.4-0.7-2.8-0.7H217v-2.8h0.7c0.8,0,1.5-0.2,1.9-0.6c0.4-0.4,0.6-0.9,0.6-1.5c0-0.6-0.2-1.1-0.5-1.4 c-0.4-0.3-0.8-0.5-1.4-0.5c-0.7,0-1.4,0.3-2.2,1l-1.9-2.1c1-0.9,1.8-1.4,2.5-1.6c0.7-0.2,1.3-0.3,1.8-0.3c1.3,0,2.5,0.4,3.4,1.2 s1.4,1.8,1.4,3.2c0,0.6-0.1,1.2-0.3,1.7c-0.2,0.6-0.8,1.2-1.7,1.8c1.9,0.9,2.9,2.3,2.9,4.4c0,1.5-0.5,2.8-1.5,3.7 c-1,0.9-2.4,1.4-4,1.4c-1,0-1.9-0.2-2.7-0.6c-0.8-0.4-1.7-1.2-2.6-2.4L215.7,57.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M227.2,44.8h3.2v6.2h5.5v-6.2h3.2v16.5h-3.2v-7.2h-5.5v7.2h-3.2V44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.8,44.8h9v3.1h-5.9v3h5.9v3h-5.9v4.3h5.9v3.1h-9V44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M270,47.7l-2.2,2.1c-1.5-1.6-3.2-2.4-5-2.4c-1.6,0-2.9,0.5-4,1.6s-1.6,2.4-1.6,4c0,1.1,0.2,2.1,0.7,2.9 s1.2,1.5,2,2c0.9,0.5,1.8,0.7,2.9,0.7c0.9,0,1.7-0.2,2.5-0.5c0.8-0.3,1.6-1,2.5-1.9l2.1,2.2c-1.2,1.2-2.4,2-3.5,2.5 s-2.3,0.7-3.7,0.7c-2.6,0-4.7-0.8-6.3-2.4c-1.6-1.6-2.5-3.7-2.5-6.3c0-1.6,0.4-3.1,1.1-4.4s1.8-2.3,3.2-3.1 c1.4-0.8,2.9-1.2,4.5-1.2c1.4,0,2.7,0.3,3.9,0.9C268,45.9,269,46.7,270,47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M277.7,44.8h3.2l6.4,16.5H284l-1.3-3.4H276l-1.3,3.4h-3.3L277.7,44.8z M279.4,49.2l-2.2,5.7h4.4L279.4,49.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.da635b99caad0818ae157ef7afb8dca8.svg";
export { ForwardRef as ReactComponent };